import calendar from "@/converters/calendar";
import categories from "@/converters/categories";
import coreNews from "@/converters/coreNews";
import departments from "@/converters/departments";
import externalDepartments from "@/converters/externalDepartments";
import externalGroups from "@/converters/externalGroups";
import groups from "@/converters/groups";
import mealDishes from "@/converters/mealDishes";
import medias from "@/converters/medias";
import meetingAgendaPoints from "@/converters/meetingAgendaPoints";
import participants from "@/converters/participants";
import profiles from "@/converters/profiles";
import pictograms from "@/converters/pictograms";
import pixabay from "@/converters/pixabay";
import planner from "@/converters/planner";
import plannerCategories from "@/converters/plannerCategories";
import plannerCustomFilters from "@/converters/plannerCustomFilters";
import plannerFilters from "@/converters/plannerFilters";
import shared from "@/converters/shared";
import workSchedule from "@/converters/workSchedule";

export default {
  calendar,
  categories,
  coreNews,
  departments,
  externalDepartments,
  externalGroups,
  groups,
  mealDishes,
  medias,
  meetingAgendaPoints,
  participants,
  profiles,
  pictograms,
  pixabay,
  planner,
  plannerCategories,
  plannerCustomFilters,
  plannerFilters,
  shared,
  workSchedule,
};
